import { statusInfo, toneOf } from "@/lib/statuses";

export const StatusBadge = ({ status, size = "sm", testId }) => {
  const info = statusInfo(status);
  const tone = toneOf(status);
  const Icon = info.icon;
  const big = size === "lg";
  return (
    <span
      className={`inline-flex items-center gap-1.5 border font-semibold whitespace-nowrap ${tone.badge} ${big ? "px-3.5 py-1.5 text-sm" : "px-2 py-0.5 text-xs"}`}
      data-testid={testId || "status-badge"}
    >
      <Icon className={big ? "h-4 w-4" : "h-3.5 w-3.5"} />
      {info.label}
    </span>
  );
};
